import { css } from 'linaria';

export const adviceSectionStyle = css`
  width: 100%;
  margin-bottom: 40px;

  @media (--to-desktop) {
    margin-bottom: 16px;
  }
`;

export const adviceSwiper = css`
  && {
    @media (--only-mobile) {
      .swiper-wrapper {
        display: flex;
        flex-direction: column;
      }
    }
  }
`;

export const adviceSlide = css`
  && {
    width: 280px;
    margin-right: 20px;
    border-radius: var(--rounding-m);

    @media (--to-desktop) {
      width: 211px;
      margin-right: 32px;
    }

    @media (--only-tablet) {
      margin-right: 16px;
    }

    @media (--only-mobile) {
      width: 100%;
      margin-right: 0;
      margin-bottom: 24px;
    }

    &:hover {
      p {
        color: var(--brand-dark);
      }
    }
  }
`;

export const adviceWrapper = css`
  @media (--only-mobile) {
    display: flex;
    align-items: center;
  }
`;

export const adviceImage = css`
  margin-bottom: 16px;
  border-radius: var(--rounding-m);

  @media (--to-desktop) {
    width: 211px;
    height: 166px;
  }

  @media (--only-mobile) {
    width: 95px;
    height: 75px;
    margin-right: 16px;
    margin-bottom: 0;
  }
`;
